import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PSPDFKit from '../pspdfkit';
import {
  getDocumentContent,
  authenticate,
  loadAnnotations,
  saveAnnotations
} from '../../api/integration';

const baseUrl = `${window.location.protocol}//${window.location.host}/${
  process.env.PUBLIC_URL
}`;

const Permissions = {
  PRINT: 111,
  ADMIN: 10000
};

function parseJwt(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));
}

export function IntegrationViewer() {
  const params = useParams();
  const [finishedLoading, setFinishedLoading] = useState(false);
  const [pdfContent, setPdfContent] = useState(null);
  const [annotations, setAnnotations] = useState(null);
  const [token, setToken] = useState(null);
  const [stage, setStage] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [allowPrinting, setAllowPrinting] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(
    () => {
      const loadDocument = async () => {
        const client = params.client;
        const tenant = params.tenant;
        const documentId = params.superid;
        const stage = params.stage;
        const isCumulativeFolder =
          window.location.href.indexOf('cumulativefolder') >= 0;

        let annotations = null;
        let pdfContent = null;
        let tmpAnnotations = null;
        try {
          const token = await authenticate(client, isCumulativeFolder);
          console.log('got token', token);
          setToken(token);

          pdfContent = await getDocumentContent(
            token,
            tenant,
            documentId,
            stage
          );
          tmpAnnotations = await loadAnnotations(
            token,
            tenant,
            documentId,
            stage
          );
          if (
            tmpAnnotations !== null &&
            tmpAnnotations.instantJson &&
            tmpAnnotations.instantJson.annotationJSON
          ) {
            annotations = tmpAnnotations.instantJson.annotationJSON;
            if (annotations.pdfId) {
              annotations.pdfId = null;
            }
          }

          if (isCumulativeFolder) {
            const payload = parseJwt(token);
            const roles = payload.customRoles;
            if (
              roles.includes(Permissions.PRINT) ||
              roles.includes(Permissions.ADMIN) ||
              roles.length === 0
            ) {
              setAllowPrinting(true);
            }
          } else {
            setAllowPrinting(true);
          }

          setFinishedLoading(true);
          setPdfContent(pdfContent);
          setAnnotations(annotations);
          setStage(stage);
          setTenant(tenant);
        } catch (error) {
          console.log('caught error');
          console.log(error);
          setError(true);
          setErrorMessage(error);
        }
      };

      loadDocument();
    },
    [params.client, params.tenant, params.superid, params.stage]
  );

  const internalSaveAnnotations = (instantJson, pageRotation) => {
    if (!instantJson.pageRotation) {
      instantJson.pageRotation = pageRotation;
    }
    const client = params.client;
    const documentId = params.superid;
    saveAnnotations(token, tenant, documentId, instantJson, stage);
  };

  let licenseKey = process.env.REACT_APP_PSPDFKIT_LICENSE;
  return (
    <div className="App">
      {error && <div>{errorMessage}</div>}
      {finishedLoading && (
        <PSPDFKit
          documentId={params.superid}
          pdfUrl={pdfContent}
          licenseKey={licenseKey}
          baseUrl={baseUrl}
          instantJSON={annotations}
          saveAnnotations={internalSaveAnnotations}
          showDelete={false}
          client={params.client}
          hidePageOrder={true}
          hideInsert={true}
          hidePrint={!allowPrinting}
        />
      )}
    </div>
  );
}

export default IntegrationViewer;
